import { Component, EventEmitter, Input, Output } from '@angular/core';
import * as _ from 'lodash';

import { PermissionsService } from '../../../permissions/permissions.service';


@Component({
  moduleId: module.id,
  selector: 'text-renderer',
  templateUrl: 'text-renderer.component.html',
  styleUrls: ['text-renderer.component.scss'],
})
export class TextRendererComponent {
  @Input() row: any;
  @Input() column: any;
  @Input() disableLink: boolean = false;
  @Input() dateFormatStr: string = 'MM/DD/YYYY';
  @Input() timezone: any;
  @Input() text: string;
  @Input() isDanger: boolean = false;
  @Input() isVersion2: boolean = false;

  @Output() infoIconClick = new EventEmitter<any>();
  @Output() linkClick = new EventEmitter<any>();
  @Output() changeFormControl = new EventEmitter<any>();

  constructor(
    private permissionsService: PermissionsService
  ) {}

  /*******************************************
   * COMPONENT GETTERS
   *******************************************/

  get columnText(): string {
    if (this.text) { return this.text; }
    if (this.column.data) {
      return this.column.data(this.row);
    } else {
      return this.columnValue;
    }
  }

  get columnValue(): string {
    return _.get(this.row, this.column.col);
  }

  get columnGhostValue(): string {
    if (this.column.ghostValue) {
      if (typeof this.column.ghostValue === 'function') {
        return this.column.ghostValue(this.row);
      } else {
        return this.column.ghostValue;
      }
    } else {
      return this.columnText;
    }
  }

  get isSelectBtn(): boolean {
    return this.column.col === 'select-btn';
  }

  get hasPermissionForLink(): boolean {
    if (this.column.permissions) {
      return this.hasPermission(this.column.permissions);
    }
    return true;
  }

  get hasColumnText(): boolean {
    return !_.isNil(this.columnText);
  }

  get isLink(): boolean {
    return (this.column.link && this.hasColumnText &&
      !this.disableLink && this.hasPermissionForLink);
  }

  get isTooltip(): boolean {
    return this.columnText || (this.row && this.row.error_message);
  }

  get tooltipContent() {
    return this.row && this.row.error_message || this.column.config.innerHtml;
  }

  /*******************************************
   * COMPONENT PUBLIC METHODS
   *******************************************/

  public hasPermission(allow: Array<string>|string, requireAll: boolean= false) {
    return this.permissionsService.hasPermission(allow, requireAll);
  }

  /*******************************************
   * COMPONENT HANDLERS
   *******************************************/

  onLinkClick() {
    this.linkClick.emit({column: this.column, row: this.row});
  }
  onChangeFormControl(event) {
    this.changeFormControl.emit({row: this.row, column: this.column, value: event});
  }
}
